module.exports = __webpack_public_path__ + "static/gq-spend-get-phase2-web-homepage-banner-gemv-mobile-9a7ec4c89165634b1bbfc909bb032092.png";